import { Container } from "reactstrap";
import styles from "./Redemption.module.scss";
import DataTable from "react-data-table-component";

const Redemption = () => {
  const data = [
    { customerId: '001', customerName: 'Lorem ipsum', redepmtionDate: '28/10/2024', lastUse: '28/10/2024 3:16am', status: 'Active' },
    { customerId: '001', customerName: 'Lorem ipsum', redepmtionDate: '28/10/2024', lastUse: '28/10/2024 3:16am', status: 'Fully redeemed' },
    { customerId: '001', customerName: 'Lorem ipsum', redepmtionDate: '28/10/2024', lastUse: '28/10/2024 3:16am', status: 'Active' },
  ];

  const columns = [
    { name: "Customer ID", selector: (row) => row.customerId, minWidth: "140px" },
    { name: "Customer name", selector: (row) => row.customerName, minWidth: "160px" },
    { name: "Redemption date", selector: (row) => row.redepmtionDate, minWidth: "160px" },
    { name: "Last use", selector: (row) => row.lastUse, minWidth: "160px" },
    { name: "Status", selector: (row) => row.status, minWidth: "140px" },
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#f2f2f2",
        fontSize: "0.938rem",
        fontWeight: 500,
        div: {
          whiteSpace: "normal",
          overflow: "visible",
        },
      },
    },
    cells: {
      style: {
        paddingBlock: "1rem",
        div: {
          whiteSpace: "normal !important",
          overflow: "visible !important",
        },
      },
    },
  };

  return (
    <section>
      <div className={styles["heading"]}>Redemption</div>
      <Container fluid className="px-5 d-flex flex-column gap-2 py-3">
        <div>
          <p>
            Total Redemptions: <span className={styles["text-orange"]}>4</span>
          </p>
        </div>

        <DataTable data={data} columns={columns} customStyles={customStyles} />
      </Container>
    </section>
  );
};

export default Redemption;